import React from "react"
import { Box, Grid, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { VerifyCatalog } from "./VerifyCatalog";
import { ManagedIdentityTokenPrintComponent } from "@internal/backstage-plugin-bidone/src/components/HelpCentre/ManagedIdentityTokenPrint";

const useStyles = makeStyles((theme: Theme) => ({
  dashboard: {
    padding: theme.spacing(4),
  },
  mainGrid: {
    marginBottom: theme.spacing(4),
  }
}));

export const HelpCentre = () => {
  const { dashboard, mainGrid } = useStyles();

  return (
    <Box className={dashboard}>
      <h1>Help Centre</h1>
      <Grid container spacing={2} className={mainGrid}>
        <Grid item xs={12} md={6} lg={4}>
          <VerifyCatalog />
        </Grid>
      </Grid>
      <ManagedIdentityTokenPrintComponent />
    </Box>
  )
}